/* eslint-env browser */
import React from 'react';
import PropTypes from 'prop-types';
import { parse as qsParse } from 'query-string';
import AutoSuggestComponent from '@aarhus-university/au-lib-react-components/src/components/AutoSuggestComponent';
import VCardComponent from './VCardComponent';
import BuildingCardComponent from './BuildingCardComponent';
import Suggestions from '../lib/Suggestions';
import {
  AUMap,
  AUMapMarker,
  AUMapGeocode,
  AUMapPolygon,
} from '../lib/AUMap';
import { T3_HOST, T3_DEFAULT_PARAMS } from '../actions/const';
import labels from '../lib/i18n';

class SearchComponent extends React.Component {
  constructor(props) {
    super(props);

    this.setResults = this.setResults.bind(this);
    this.setMarker = this.setMarker.bind(this);

    this.state = {
      auMap: null,
      locations: [],
      results: [],
    };

    this.parseQueryStrings = this.parseQueryStrings.bind(this);
    this.cludo = false;
  }

  componentDidMount() {
    const {
      container,
      width,
      height,
      zoom,
      center,
      scrollable,
      draggable,
      clickable,
      streetview,
      map,
    } = this.props;
    if (map) {
      const auMap = new AUMap(
        document.getElementById(container),
        width,
        height,
        zoom,
        center,
        scrollable,
        draggable,
        clickable,
        streetview,
        () => {
          const { results } = this.state;
          const { lang } = this.props;
          if (results.length === 1) {
            const r = results[0];
            const id = !r.type && r.departments.length > 0 ? r.departments[0].email : r.id;
            const mapUrl = `http://www.au.dk/${lang === 'da'
              ? 'kort/' : 'en/map/'}?${r.type ? 'b' : 'p'}=${id}`;
            window.location.href = mapUrl;
          }
        },
      );
      this.setState({
        auMap,
      }, () => {
        this.getLocations(() => {
          this.parseQueryStrings();
        });
      });

      window.addEventListener('hashchange', () => {
        this.parseQueryStrings();
      });
    } else {
      this.getLocations();
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const nextLocations = nextProps.locations;
    if (prevState.locations.length === 0) {
      return {
        locations: nextLocations,
      };
    }

    return null;
  }

  getDataPath() {
    const { lang } = this.props;
    const langQuery = `&lang=${(lang === 'da' ? 1 : 2)}`;
    return T3_HOST + T3_DEFAULT_PARAMS + langQuery;
  }

  getLocations(callback) {
    const { fetchLocally, getLocations } = this.props;
    if (fetchLocally) {
      fetch(this.getDataPath()).then((promise) => promise.json()).then((data) => {
        const { locations } = data;
        this.setState({
          locations,
        }, () => {
          if (typeof callback === 'function') {
            callback(locations);
          }
        });
      });
    } else {
      getLocations();
    }
  }

  setMarker(result, lat, lng) {
    const { auMap: map } = this.state;
    if (map) {
      const marker = new AUMapMarker(
        map, { lat, lng }, 'https://cdn.au.dk/res/images/maps/marker_generic.png',
        false,
        true,
        true,
        true,
        12,
        '',
        result.id,
      );
      map.setCenter(marker);
    }
  }

  setResults(newResults, clear = true) {
    const {
      auMap: map,
      results: sResults,
      locations,
    } = this.state;
    const { map: pMap } = this.props;
    const results = clear ? [] : sResults;
    this.setState({
      results: [...results, ...newResults],
    }, () => {
      if (map && newResults.length === 0 && clear) {
        map.clearMarkers();
      }
      newResults.forEach((result, i) => {
        if (map && i === 0 && clear) {
          map.clearMarkers();
          map.clearPolygons();
        }
        // Building or location
        if (result.latitude && result.longitude) {
          if (result.coordinates?.length > 0 && pMap) {
            // eslint-disable-next-line max-len
            this.drawPolygon(result.coordinates.map((c) => ({ lat: c.latitude, lng: c.longitude })), parseFloat(result.latitude), parseFloat(result.longitude));
          } else {
            this.setMarker(result, parseFloat(result.latitude), parseFloat(result.longitude));
          }
        } else if (result.departments) {
          // Person
          result.departments.forEach((d) => {
            const { building } = d.address;
            const foundBuilding = building ? locations.find((x) => x.id === building.id) : null;
            if (foundBuilding && pMap) {
              // eslint-disable-next-line max-len
              this.drawPolygon(foundBuilding.coordinates.map((c) => ({ lat: c.latitude, lng: c.longitude })), parseFloat(foundBuilding.latitude), parseFloat(foundBuilding.longitude));
            } else {
              const address = `${d.address.street} ${d.address.zip} ${d.address.city}`;
              AUMapGeocode.lookupAddress(map, address, (point) => {
                this.setMarker(result, point.lat(), point.lng());/*
              if (result.departments.length > 0) {
                if (updateResults) {
                  this.getOftenSearch(this.state.locations, result.departments[0].email);
                }
              } */
              });
            }
          });
        } else {
          // Department
          AUMapGeocode.lookupAddress(map, result.address, (point) => {
            this.setMarker(result, point.lat(), point.lng());
          });
        }
      });
    });
  }

  drawPolygon(coordinates, centerLat, centerLng) {
    const { auMap } = this.state;
    const map = auMap;
    // eslint-disable-next-line no-new
    new AUMapPolygon(map, coordinates, centerLat, centerLng);
  }

  parseQueryStrings() {
    const { locations } = this.state;
    const qs = qsParse(window.location.search);
    let param = qs.b || qs.p || qs.e || qs.os;
    if (!param) {
      const hash = qsParse(window.location.hash.replace('?', ''));
      if (hash.cludoquery && hash.cludoquery.indexOf(' ') > -1) {
        param = hash.cludoquery;
        this.cludo = true;
      }
    } else {
      this.cludo = false;
    }
    if (param) {
      Suggestions.getSuggestions(param, locations, (newResults) => {
        const promises = [];
        newResults.forEach((r) => {
          if (!r.type) {
            promises.push(new Promise((resolve) => {
              resolve(r);
            }));
          } else if (r.departmentsdetails) {
            promises.push(new Promise((resolve) => {
              Suggestions.getDepartmentDetails(r, locations, (department) => {
                resolve(department);
              });
            }));
          } else {
            promises.push(new Promise((resolve) => {
              Suggestions.getBuildingDetails(r, locations, (building) => {
                resolve(building);
              });
            }));
          }
        });
        Promise.all(promises).then((values) => {
          this.setResults(values);
        });
      });

      return true;
    }

    return false;
  }

  render() {
    const {
      lang,
      className,
      sideBySide,
      container,
    } = this.props;
    const { results, locations } = this.state;
    const mapUrl = lang === 'da' ? 'kort/' : 'en/map/';
    const slice = this.cludo ? 5 : results.length;
    const renderResult = results.slice(0, slice).map((r) => {
      if (r.type) {
        return (
          <BuildingCardComponent
            key={r.id}
            id={r.id}
            mapUrl={mapUrl}
            names={r.names}
            address={r.address}
            persons={[]}
            personClick={(persons) => {
              if (persons.length > 0) {
                window.location.href = `//www.au.dk/${mapUrl}?p=${persons[0].email}`;
              }
            }}
            locations={locations}
            labels={{
              building: labels[lang].building,
              showOnMap: labels[lang].showOnMap,
            }}
            forPopup={false}
          />
        );
      }

      const pureUrl = `http://au.dk/${r.departments[0].email}`;
      const mailTo = `mailto:${r.departments[0].email}`;

      return (
        <VCardComponent
          key={r.id}
          pureUrl={pureUrl}
          mapUrl={mapUrl}
          mailTo={mailTo}
          fullName={r.fullName}
          photo={r.photo}
          departments={r.departments}
          buildingClick={(buildings) => {
            if (buildings.length > 0) {
              window.location.href = `//www.au.dk/${mapUrl}?b=${buildings[0].id}`;
            }
          }}
          locations={locations}
          labels={{
            building: labels[lang].building,
            showOnMap: labels[lang].showOnMap,
          }}
          forPopup={false}
        />
      );
    });

    const columnClass = sideBySide ? 'column large-6 medium-6 small-6' : 'column large-12 medium-12 small-12';

    return (
      <div className={className}>
        <div className={columnClass}>
          <h3>
            {labels[lang].search}
          </h3>
          <AutoSuggestComponent
            placeholder={labels[lang].search}
            setQuery={() => { }}
            setResults={this.setResults}
            collection={locations}
            getSuggestions={Suggestions.getSuggestions}
            getSuggestionValue={Suggestions.getSuggestionValue}
            renderSuggestion={Suggestions.renderSuggestion}
            clearInput
          />
        </div>
        <div className={columnClass}>
          <div id={container} />
          {renderResult}
        </div>
      </div>
    );
  }
}

SearchComponent.defaultProps = {
  map: true,
};

SearchComponent.propTypes = {
  map: PropTypes.bool,
  lang: PropTypes.string.isRequired,
  container: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  zoom: PropTypes.number.isRequired,
  center: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }).isRequired,
  scrollable: PropTypes.bool.isRequired,
  draggable: PropTypes.bool.isRequired,
  clickable: PropTypes.bool.isRequired,
  streetview: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  sideBySide: PropTypes.bool.isRequired,
  fetchLocally: PropTypes.bool.isRequired,
  getLocations: PropTypes.func.isRequired,
  locations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
SearchComponent.displayName = 'SearchComponent';
export default SearchComponent;
